module.exports = __webpack_public_path__ + "static/media/DSC_0188.b35bbe74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0188.jpg
// module id = 643
// module chunks = 0